import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { modalActions } from "../../storage/modals";
import { cartActions } from "../../storage/cart";

const Promocodes = (props) => {
//   const [cookies, setCookies] = useCookies();
  const dispatch = useDispatch();
  const promocodes = useSelector((state) => state.modals.promocodes.list);
  const [chosenPromo, setChosenPromo] = useState(-1);

  const closeHandler = () => {
    // setCookies("promoModal", "hidden", { path: "/" });
    dispatch(modalActions.hideAllModals());
  };

  const setChosenPromoHandler = (index) => {
    setChosenPromo(index);
  };

  const submitPromocode = () =>{
    dispatch(cartActions.setPromocode(promocodes[chosenPromo].code));
    closeHandler();
  }

  return (
    <div className="modal-window modal-window_promocode">
      <div className="modal-promo-header">
        <button
          type="button"
          className="modal-close"
          onClick={props.closeHandler}
        ></button>
      </div>
      <div className="modal-promo-body">
        <h5 className="modal-promo-greeting">Привет!</h5>
        <p className="modal-promo-description">
          У нас для тебя есть промокод, который ты можешь применить во время
          покупки в нашем магазине!
        </p>
        <p className="modal-promo-alert">
          Выбери промокод, который хочешь использовать и мы автоматически
          применим его в твоей корзине:
        </p>
        <div className="modal-promo-options">
          {promocodes.map((item, index) => (
            <div
              className={
                chosenPromo === index
                  ? "modal-promo-option modal-promo-option_selected"
                  : "modal-promo-option"
              }
              key={index}
              onClick={() => {
                setChosenPromoHandler(index);
              }}
            >
              <span className="modal-promo-option__marker"></span>
              <p className="modal-promo-option-title">
                {item.code} –
                <span className="modal-promo-option-title__bold">
                  {item.discount}%
                </span>
              </p>
            </div>
          ))}
        </div>
      </div>
      <button type="button" className="modal-btn modal-btn_promocode" disabled={chosenPromo < 0} onClick={submitPromocode}>
        Спасибо, погнали!
      </button>
      <button type="button" className="modal-btn-clear" onClick={closeHandler}>
        Не надо мне ничего, сам куплю
      </button>
    </div>
  );
};

export default Promocodes;
